// extracted by mini-css-extract-plugin
export default {"header":"DIDCallLogsTableDesktop_header__1aKNJ","rows":"DIDCallLogsTableDesktop_rows__MAb3X","row":"DIDCallLogsTableDesktop_row__l4pcq"};